import { render } from "./GroupReport.vue?vue&type=template&id=4849ad37&scoped=true"
import script from "./GroupReport.vue?vue&type=script&lang=js"
export * from "./GroupReport.vue?vue&type=script&lang=js"

import "./GroupReport.vue?vue&type=style&index=0&id=4849ad37&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4849ad37"]])

export default __exports__